import React from 'react'
import { Icon } from 'antd'
import { withTranslation } from 'react-i18next'
import './TableEmpty.css'

function TableEmpty({ t, title, description }) {
  return <div className='table-empty' role='status'>
    <Icon type='unordered-list' aria-hidden='true' />
    <p className='table-empty-title'>{title || t('tableEmpty.title')}</p>
    {description && <p className='table-empty-description'>{description}</p>}
  </div>
}

export default withTranslation()(TableEmpty)
